import { render, staticRenderFns } from "./Students.html?vue&type=template&id=eb06ecdc&scoped=true&external"
import script from "./Students.js?vue&type=script&lang=js&external"
export * from "./Students.js?vue&type=script&lang=js&external"
import style0 from "./Students.vue?vue&type=style&index=0&id=eb06ecdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb06ecdc",
  null
  
)

export default component.exports